import { path } from "d3";

let children = [];

//General
children.push({
    path: "/general/Sistemas",
    name: "GEN_SYSTEM",
    component: () =>
        import("../views/General/System.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Sistemas", href: "/general/Sistemas" },
        ],
    },
});

children.push({
    path: "/general/dar_baja",
    name: "GEN_UNSUBSCRIBE",
    component: () =>
        import("../views/General/Unsubscribe.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Dar de Baja", href: "/general/dar_baja" },
        ],
    },
});

children.push({
    path: "/general/subir_archivos",
    name: "GEN_UPLOAD_FILES",
    component: () =>
        import("../views/General/UploadFiles.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Subir Archivos", href: "/general/subir_archivos" },
        ],
    },
});

children.push({
    path: "/general/firma",
    name: "GEN_SIGNATURE",
    component: () =>
        import("../views/General/Signature.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Firma", href: "/general/firma" },
        ],
    },
});

children.push({
    path: "/general/Area",
    name: "GEN_AREA",
    component: () =>
        import("../views/General/Area.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Áreas", href: "/general/Area" },
        ],
    },
});

children.push({
    path: "/general/subir_firmas",
    name: "GEN_UPLOAD_SIGNATURES",
    component: () =>
        import("../views/General/UploadSignatures.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Subir Firmas", href: "/general/subir_firmas" },
        ],
    },
});

children.push({
    path: "/general/campana",
    name: "GEN_CAMPAIGN",
    component: () =>
        import("../views/General/Campaign.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Campañas", href: "/general/campana" },
        ],
    },
});

children.push({
    path: "/general/inductores",
    name: "GEN_INDUCTORS",
    component: () =>
        import("../views/General/Inductors.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Inductores", href: "/general/inductores" },
        ],
    },
});

children.push({
    path: "/general/definicion",
    name: "GEN_DEFINITION",
    component: () =>
        import("../views/General/Definition.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Definición", href: "/general/definicion" },
        ],
    },
});
children.push({
    path: "/general/persona",
    name: "GEN_PERSON",
    component: () =>
        import("../views/General/Person.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Persona", href: "/general/persona" },
        ],
    },
});

children.push({
    path: "/general/persona_masiva",
    name: "GEN_PERSON_MASSIVE",
    component: () =>
        import("../views/General/PersonMassive.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Persona Masiva", href: "/general/persona_masiva" },
        ],
    },
});

children.push({
    path: "/general/grupodefinicion",
    name: "GEN_DEFINITIONGROUP",
    component: () =>
        import("../views/General/DefinitionGroup.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Grupo de Definición", href: "/general/grupodefinicion" },
        ],
    },
});

children.push({
    path: "/general/numeracion",
    name: "GEN_NUMERATION",
    component: () =>
        import("../views/General/Numeration.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Numeración de Tabla", href: "/general/numeracion" },
        ],
    },
});

children.push({
    path: "/general/numeraciondocumento",
    name: "GEN_NUMERATIONDOCUMENT",
    component: () =>
        import("../views/General/NumerationDocument.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            {
                text: "Numeración de Documentos",
                href: "/general/numeraciondocumento",
            },
        ],
    },
});

children.push({
    path: "/general/parametro",
    name: "GEN_PARAMETER",
    component: () =>
        import("../views/General/Parameter.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Parametros", href: "/general/parametro" },
        ],
    },
});

children.push({
    path: "/general/temas",
    name: "MNG_INSTRUCTIONSUBJECT",
    component: () =>
        import("../views/Management/InstructionSubject.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Temas", href: "/general/temas" },
        ],
    },
});
children.push({
    path: "/general/parametrosconfiguracion",
    name: "GEN_PARAMETER_CONFIGURATION",
    component: () =>
        import("../views/General/Propertys.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Parametros Configuracion", href: "/general/parametrosconfiguracion" },
        ],
    },
});

children.push({
    path: "/general/logerrores",
    name: "GEN_LOG_ERRORS",
    component: () =>
        import("../views/General/LogErrors/Log.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Log de Errores", href: "/general/logerrores" },
        ],
    },
});

children.push({
    path: "/produccionfrescos/whatsapp",
    name: "GEN_WHATSAPP",
    component: () =>
        import("../views/FreshProduction/WhatsApp/whatsapp.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Producción Frescos", disabled: true },
            { text: "WhatsApp", href: "/produccionfrescos/whatsapp" }
        ],
    },
});

children.push({
    path: "/general/SunarpSearch",
    name: "GEN_SEARCHSUNARP",
    component: () =>
        import("../views/General/Sunarp/SunarpSearch.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Consulta Sunarp", href: "/general/SunarpSearch" }
        ],
    },
});


children.push({
    path: "/general/WorkerReport",
    name: "GEN_REPORT_WORKER",
    component: () =>
        import("../views/General/ReportWorker/ReportWorker.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Reporte Trabajador", href: "/general/WorkerReport" }
        ],
    },
});

children.push({
    path: "/general/campanaporarea",
    name: "GEN_CAMPAIGN_AREA",
    component: () =>
        import("../views/General/CampaignArea/CampaignArea.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Campaña por área", href: "/general/campanaporarea" }
        ],
    },
});

children.push({
    path: "/general/visitas",
    name: "GEN_PERSON_VISIT",
    component: () =>
        import("../views/General/PersonVisit/PersonVisit.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Visitas", href: "/general/visitas" }
        ],
    },
});

children.push({
    path: "/general/permisoparametro",
    name: "GEN_PARAMETER_PERMISSION",
    component: () =>
        import("../views/General/ParameterPermission.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Permisos de Parámetros", href: "/general/permisoparametro" },
        ],
    },
});
//alias de tabals
children.push({
    path: "/general/alias",
    name: "GEN_ALIAS",
    component: () =>
        import("../views/General/Alias/AliasG.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Alias de Objetos", href: "/general/alias" },
        ],
    },
});
//firmas DNIe 
// children.push({
//     path: "/general/firma_dnie",
//     name: "GEN_SIGNATURE_DNIE",
//     component: () => import ("../views/General/Implementations/SignatureDNIeEditor.vue"),
//     meta: {
//         authenticated: true,
//         breadcrumb: [
//             { text: "Inicio", href: "/#/" },
//             { text: "General", disabled: true },
//             { text: "Firma DNIe", href: "/general/firma_dnie" },
//         ],
//     },
// });
// Firma Masiva DNIe
children.push({
    path: "/general/firma_masiva_dnie",
    //     name: "GEN_SIGNATURE_DNIE",
    name: "GEN_BATCH_SIGNATURE_DNIE",
    component: () => import("../views/General/Implementations/BatchSignatureDNIe.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Firma Masiva DNIe", href: "/general/firma_masiva_dnie" },
        ],
    },
});

// Crear Circuito de Firmas
children.push({
    path: "/general/crear_circuito_firmas",
    name: "GEN_SIGNATURE_DNIE",
    // name: "GEN_CREATE_SIGNATURE_CIRCUIT",
    component: () => import("../views/General/Implementations/SignatureDNIeEditor.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Crear Circuito Firmas", href: "/general/crear_circuito_firmas" },
        ],
    },
});

// Crear Circuito de Firmas
children.push({
    path: "/general/envio_documentos_firma",
    name: "TAS_DOCUMENT_SIGNATURE_REQUEST",
    // name: "GEN_CREATE_SIGNATURE_CIRCUIT",
    component: () => import("../views/General/DocumentSignatureSender.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Envio de documentos firma", href: "/general/envio_documentos_firma" },
        ],
    },
});
// Crear Circuito de Firmas
children.push({
    path: "/general/firma_documentos",
    name: "TAS_HARVEST_GUIDE_CONFIRMATION",
    // name: "GEN_CREATE_SIGNATURE_CIRCUIT",
    component: () => import("../views/General/DocumentSignature.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "General", disabled: true },
            { text: "Envio de documentos firma", href: "/general/firma_documentos" },
        ],
    },
});


export { children };